import {NavigationHelpers} from '@react-navigation/native';
import {LocalParamList} from '../../shared/components/tabBar/components/types';
import View, {IStateProps} from './view';
import {Screens} from '../../shared/routing';
import {VisuallyImpairedForm} from '../../shared/components/visuallyImpaired/form';
import {useDispatch} from 'react-redux';
import {changeThemeProperty} from '../../redux/actions/runtime/theme';
import {VisImpStatus} from '../../shared/models/visuallyImpairedSettings';
import {useCallback} from 'react';

export interface Props {
  navigation: NavigationHelpers<LocalParamList>;
}

export const VisuallyImpairedSettingsLoginScreen = ({navigation}: Props) => {
  const dispatch = useDispatch();
  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(Screens.Login);
    }
  }, [navigation]);
  const onDefaultVersion = useCallback(() => {
    goBack();
    dispatch(changeThemeProperty('visuallyImpaired', VisImpStatus.Disabled));
  }, [goBack, dispatch]);
  const props: IStateProps = {
    onDefaultVersion,
    onGoBackClick: goBack,
  };

  return VisuallyImpairedForm<IStateProps>({
    render: View,
    props,
  });
};
